import React, { useEffect, useRef } from 'react';
import './NewChatDropdown.css';

function NewChatDropdown({ show, onClose, onSelectAIChat, onSelectJournal, dailyLimitReached, resetsInMessage }) {
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    if (!show) return;

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className="new-chat-dropdown" ref={dropdownRef} onClick={(e) => e.stopPropagation()}>
      <div className="dropdown-content">
        <button
          className={`dropdown-option ${dailyLimitReached ? 'disabled' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            if (!dailyLimitReached) {
              onSelectAIChat();
              onClose();
            }
          }}
          disabled={dailyLimitReached}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" fill="currentColor"/>
          </svg>
          <div className="option-text">
            <div className="option-title">Chat with 3AM AI</div>
            {dailyLimitReached && (
              <div className="option-subtitle">{resetsInMessage || 'Daily limit reached'}</div>
            )}
          </div>
        </button>
        
        <button
          className="dropdown-option"
          onClick={(e) => {
            e.stopPropagation();
            onSelectJournal();
            onClose();
          }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 19l7-7 3 3-7 7-3-3z" />
            <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
          </svg>
          <div className="option-text">
            <div className="option-title">New Journal</div>
            <div className="option-subtitle">Unlimited, no AI</div>
          </div>
        </button>
      </div>
    </div>
  );
}

export default NewChatDropdown;
